var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"AppLayout"}},[_c('app-header'),_c('app-sidebar'),_c('main',{staticClass:"content-wrapper-app-layout"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }